export default __webpack_public_path__ + "static/media/Carrascal.1b248673.jpg";